import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-financiamiento',
  templateUrl: './financiamiento.component.html',
  styleUrls: ['./financiamiento.component.scss']
})
export class FinanciamientoComponent  {

  constructor(private loginService:LoginService) { }



  clickGuard(){
    this.loginService.clickGuard = true;
 }


}
